export class CookieService {
    static getCookie(cookieName: string): string | undefined {
        let result: string | undefined = undefined;
        let cookies: string[] = document.cookie.split(";");

        cookies.forEach(o => {
            let cookie: string[] = o.split("=");
            let name: string = cookie[0].trim();
            if (name === cookieName) {
                cookie.splice(0, 1);
                result = cookie.join('=');
            }
        });
        return result;
    }

    static setCookie(name: string, value: string, expiryDays?: number): boolean {
        let expires = "";
        if (expiryDays) {
            let date = new Date();
            date.setTime(date.getTime() + expiryDays * 24 * 60 * 60 * 1000);
            expires = `expires=${date.toUTCString()}`;
        }
        if (document.location.protocol === "http:") {
            document.cookie = `${name}=${value};${expires};path=/;`; // Pour Http
        } else {
            document.cookie = `${name}=${value};path=/;Secure;${expires}`; // Pour Https
        }
        return true;
    }

    static cleanCookie(name: string) {
        const pastDate = new Date(0).toUTCString();

        if (document.location.host.includes("localhost")) {
            document.cookie = `${name}=; expires=${pastDate}`;
        } else {
            document.cookie = `${name}=; Secure; expires=${pastDate}`;
        }
    }
}